// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1rb4A","dragIcon":"SortableItem_dragIcon__drR2F","disabled":"SortableItem_disabled__2eTsw"};